import React from 'react';
import { Box } from '@chakra-ui/react';

const MainSection = props => {
  return <Box display={'flex'} flex={2} flexDirection={'column'} {...props} />;
};

export default MainSection;
